import { TFunction } from "i18next";
import { ErrorTypes } from "../../types/errors/errors";

export const errorTranslations: Record<ErrorTypes, string> = {
  [ErrorTypes.INVALID_ENTITY]: "generic.errors.invalid-entity",
  [ErrorTypes.NO_PERMISSION_ENTITY]: "generic.errors.no-permission-entity",
  [ErrorTypes.INVALID_MANAGEMENT_UNIT]:
    "generic.errors.invalid-management-unit",
  [ErrorTypes.MISSING_COORDINATES]: "generic.errors.missing-coordinates",
  [ErrorTypes.MANAGEMENT_UNIT_ENTITY_MISMATCH]:
    "generic.errors.management-unit-entity-mismatch",
  [ErrorTypes.INVALID_DROPDOWN_VALUE]: "generic.errors.invalid-dropdown-value",
  [ErrorTypes.UNKNOWN]: "generic.errors.unknown",
  [ErrorTypes.ACCOUNT_EXISTS]: "generic.errors.account-exists",
  [ErrorTypes.ACCOUNT_UNKNOWN]: "generic.errors.account-unknown",
  [ErrorTypes.USER_EXISTS]: "generic.errors.user-exists",
  [ErrorTypes.USER_UNKNOWN]: "generic.errors.user-unknown",
  [ErrorTypes.EMAIL_EXISTS]: "generic.errors.email-exists",
  [ErrorTypes.INVALID_PARAMETERS]: "generic.errors.invalid-parameters",
  [ErrorTypes.UNAUTHORIZED]: "generic.errors.unauthorized",
  [ErrorTypes.ACCOUNT_CREATION_FAILED]:
    "generic.errors.account-creation-failed",
  [ErrorTypes.ACCOUNT_UPDATE_FAILED]: "generic.errors.account-update-failed",
  [ErrorTypes.USER_CREATION_FAILED]: "generic.errors.user-creation-failed",
  [ErrorTypes.USER_UPDATE_FAILED]: "generic.errors.user-update-failed",
  [ErrorTypes.USER_DELETION_FAILED]: "generic.errors.user-deletion-failed",
  [ErrorTypes.USER_PASSWORD_UPDATE_FAILED]:
    "generic.errors.user-password-update-failed",
  [ErrorTypes.USER_PREFERENCES_UPDATE_FAILED]:
    "generic.errors.user-preferences-update-failed",
  [ErrorTypes.USER_DISABLED]: "generic.errors.user-disabled",
  [ErrorTypes.USER_NOT_FOUND]: "generic.errors.user-not-found",
  [ErrorTypes.USERS_NOT_FOUND]: "generic.errors.users-not-found",
  [ErrorTypes.NOT_FOUND]: "generic.errors.not-found",
  [ErrorTypes.LOCATION_EXISTS]: "generic.errors.location-exists",
  [ErrorTypes.DUPLICATE_ENTRY]: "generic.errors.duplicate-entry",
  [ErrorTypes.PROCESSING_ERROR]: "generic.errors.processing-error",
};

interface ValidationErrorDetail {
  path: string[];
  message: string;
  code: string;
}

export const getErrorMessage = (
  code: ErrorTypes,
  t: TFunction,
  field?: string,
  validationErrors?: ValidationErrorDetail[],
) => {
  if (code === ErrorTypes.INVALID_PARAMETERS && validationErrors?.length) {
    const fields = validationErrors
      .map(e => t(`calculations.methods.inputs.${e.path[0]}`, { defaultValue: e.path[0] }))
      .join(", ");

    return t(errorTranslations[code], { field: fields });
  }

  const key = errorTranslations[code] ?? errorTranslations[ErrorTypes.UNKNOWN];
  return t(key, { field });
};
